"use client"
import React from 'react';
import {Button, Container, Typography} from "@mui/material";
import {useTheme} from "@mui/material/styles";
import softwareSearchImage from '/public/images/screenshots/software-search.png';
import softwarePlot from '/public/images/screenshots/software-plot.png';
import softwareProduct from '/public/images/screenshots/software-product.png';
import softwareAccount from '/public/images/screenshots/software-accounts.png';
import softwareFactor from '/public/images/screenshots/software-factor.png';
import softwareHeroImage from '/public/images/icons/SoftwareHero.png';
import callingMan from '/public/images/icons/Man-calling.png';
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import shapes from '/public/images/icons/Shapes.png'
import accounting from '/public/images/icons/Accounting.png'
import network from '/public/images/icons/Network.png'
import FaIcon from "@/components/utilities/fa-icon";
import SoftwareSection from "./software-section";
import SoftwareFeatureCard from "./software-feature-card";


export default function SoftwareView() {
    const theme = useTheme();

    return (
        <  >
            <Container maxWidth = 'lg' sx = {{py: 6}} >
                <SoftwareSection
                    isHero
                    title = "نرم‌افزار حسابداری پیکان پارس؛ مدیریت مالی هوشمند برای کسب‌وکارهای لوازم یدکی"
                    description = {`   نرم‌افزار حسابداری پیکان‌پارس، اولین و جامع‌ترین سیستم مدیریت مالی ویژه فروشندگان لوازم یدکی خودرو است.
          با رابط کاربری ساده، سرعت بالا و امکانات پیشرفته، حسابداری، مدیریت انبار، فروش و گزارش‌گیری را در یک محیط حرفه‌ای تجربه کنید.`}
                    image = {softwareHeroImage}
                >
                    <a href = "#contact-to-order" >
                        <Button
                            startIcon = {<FaIcon faIcon = 'fa-phone' />}
                            color = 'secondary'
                            variant = 'contained'
                        >
                            تماس و ثبت سفارش
                        </Button >
                    </a >

                    <Button variant = 'outlined' >
                        اطلاعات بیشتر
                    </Button >
                </SoftwareSection >
                <SoftwareSection
                    isReverse
                    title = "جستجوی سریع و هوشمند در محصولات و حساب‌ها"
                    description = {` با قابلیت جستجوی پیشرفته در نرم‌افزار حسابداری پیکان پارس، می‌توانید در میان هزاران محصول، مشتری، حساب و سند مالی تنها در چند ثانیه نتیجه دلخواه خود را بیابید.
          فیلترهای دقیق و جستجوی هوشمند به شما کمک می‌کند سریع‌تر تصمیم بگیرید و کارآمدتر عمل کنید.`}
                    image = {softwareSearchImage}
                >
                    <Button variant = "outlined" >اطلاعات بیشتر</Button >
                </SoftwareSection >

                <SoftwareSection
                    title = "گزارش‌گیری مالی و نمایش نمودارهای تحلیلی"
                    description = {`با گزارش‌های تحلیلی و نمودارهای تعاملی نرم‌افزار پیکان پارس، عملکرد مالی خود را به‌صورت روزانه، ماهانه یا فصلی تحلیل کنید.
          مشاهده‌ی میزان فروش، سود و زیان، گردش کالا و گزارش‌های کاربران به شما دید کاملی از وضعیت کسب‌وکارتان می‌دهد.`}
                    image = {softwarePlot}
                >
                    <Button variant = "outlined" >اطلاعات بیشتر</Button >
                </SoftwareSection >

                <SoftwareSection
                    isReverse
                    title = "مدیریت حرفه‌ای محصولات و کالاها"
                    description = {`محصولات خود را با جزئیاتی مانند شرکت سازنده، نوع خودرو، شماره فنی، و صفات سفارشی در سیستم ثبت کنید.
          امکاناتی مانند کاردکس کالا، گردش موجودی و گزارش سود و زیان هر کالا، مدیریت انبار شما را دقیق‌تر و سریع‌تر می‌کند.`}
                    image = {softwareProduct}
                >
                    <Button variant = "outlined" >اطلاعات بیشتر</Button >
                </SoftwareSection >

                <SoftwareSection
                    title = "مدیریت کاربران و سطوح دسترسی"
                    description = {`امنیت اطلاعات مالی شما در اولویت است. در نرم‌افزار حسابداری پیکان پارس می‌توانید برای هر کاربر سطح دسترسی مجزا تعیین کنید تا فقط اطلاعات مجاز در دسترس باشد.
          این قابلیت برای مدیران و حسابداران چندکاربره بسیار مفید است.`}
                    image = {softwareAccount}
                >
                    <Button variant = "outlined" >اطلاعات بیشتر</Button >
                </SoftwareSection >

                <SoftwareSection
                    isReverse
                    title = "ثبت اسناد مالی و فاکتورهای فروش"
                    description = {`فاکتورهای فروش، دریافت و پرداخت، چک‌ها، حقوق پرسنل و سایر اسناد مالی خود را به‌سادگی در نرم‌افزار ثبت کنید.
          تخفیف درصدی و ریالی، مدیریت موعد تسویه و گزارش‌گیری دقیق از فاکتورها، تنها بخشی از امکانات پیشرفته پیکان پارس هستند.`}
                    image = {softwareFactor}
                >
                    <Button variant = "outlined" >اطلاعات بیشتر</Button >
                </SoftwareSection >
            </Container >

            <Box bgcolor={theme.palette.primary.dark} >
                <Container maxWidth = 'md' sx = {{py: 6}} >
                    <Typography
                        fontSize = {24}
                        variant = "h2"
                        color = "common.white"
                        textAlign = "center"
                        sx = {{mb: 10}}
                    >
                        قابلیت‌های منحصر‌به‌فرد
                    </Typography >

                    <Grid container spacing = {{sm: 4, xs: 8}} >
                        <Grid item xs = {12} sm = {4} >
                            <SoftwareFeatureCard
                                title = "طراحی ساده و قابل فهم"
                                description = "رابط کاربری مدرن و دسته‌بندی‌شده که کار با نرم‌افزار را برای همه کاربران آسان و سریع می‌کند."
                                image = {shapes}
                            />
                        </Grid >

                        <Grid item xs = {12} sm = {4} >
                            <SoftwareFeatureCard
                                title = "بر پایه اصول حسابداری"
                                description = "طراحی‌شده مطابق اصول دقیق حسابداری تا کاربران بدون دانش تخصصی هم بتوانند امور مالی را مدیریت کنند."
                                image = {accounting}
                            />
                        </Grid >

                        <Grid item xs = {12} sm = {4} >
                            <SoftwareFeatureCard
                                title = "قابلیت اجرای شبکه‌ای"
                                description = "امکان اجرا بر روی چند سیستم و همگام‌سازی کامل داده‌ها در شبکه محلی یا سازمانی."
                                image = {network}
                            />
                        </Grid >
                    </Grid >
                </Container >
            </Box >

            <Container maxWidth = 'md' sx = {{mt: 4, mb: {xs: 0, md: -4}}} >
                <div id = 'contact-to-order' >
                    <SoftwareSection
                        title = 'برای سفارش تماس بگیرید...'
                        description = {`
جهت دریافت مشاوره رایگان و سفارش نرم‌افزار حسابداری پیکان پارس از طریق شماره زیر، یا با استفاده از پیامرسان پیکان پارس با کارشناسان ما تماس حاصل نمایید.                    `}
                        image = {callingMan}
                    >
                        <a href = "tel:+985138514400" >
                            <Button
                                startIcon = {<FaIcon faIcon = 'fa-phone' />}
                                color = 'secondary'
                                variant = 'contained' >
                            <span dir = 'ltr' >
                               (051) 385 27659
                            </span >

                            </Button >
                        </a >
                    </SoftwareSection >
                </div >

            </Container >

        </ >
    );
};